import React from 'react';
import { Form, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import { Constants } from "../../constants";
import axios, { AxiosRequestConfig } from 'axios';
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';



function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class CustomerStatementPage extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            loading: false,
            data: [],
            account: props.location.state.account
        };

        this.handleTableChange = this.handleTableChange.bind(this);
        this.loadingSpinner = this.loadingSpinner.bind(this);
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        this.setState({loading: true});
        axios.get(`${Constants.apiURL}/api/Request/statement/search`, {
            params: {
                accountID: this.state.account.accountID
            }
        }).then(response => {

            console.log(response);
            if (response.data) {

                this.setState(() => ({
                    data: response.data,
                    loading: false
                }));
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }


    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No statements found.';
        }
    };

    render() {
        const { data, sizePerPage, page } = this.state;
        const columns = [
            {
                dataField: 'EntryDate',
                text: 'Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DocumentID',
                align: 'center',
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Button name="serviceNext" size="sm" style={{ width: '120px', marginLeft: 5 }} onClick={() => {

                        axios.get(`${Constants.apiURL}/api/Request/statement/download`, {
                            params: {
                                user: this.state.user.username,
                                documentKey: row.DocumentID,
                                accountID: this.state.account.accountID
                            },
                            responseType: 'blob'
                        }).then(response => {
                            if (response.data == 'No files found.') return;
                            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                                downloadUrl = window.URL.createObjectURL(blob),
                                filename = "",
                                disposition = response.headers["content-disposition"];

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                                    matches = filenameRegex.exec(disposition);

                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }
                            else {
                                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                                return;
                            }

                            let a = document.createElement("a");
                            if (typeof a.download === "undefined") {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                            downloadUrl.revokeObjectURL();
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                            console.log('request failed', response)
                        });

                    }}> Download</Button >
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '80px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            }
        ];
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='customerStatementPage' />
                <Form.Label className="form-header" style={{ padding: '10px 00px 0px 10px', marginBottom: 0 }}>Please find most recent customer account statement below.</Form.Label>
                <br />
                <Form.Label style={{ fontStyle: 'italic', fontSize: '14px', padding: '0px 0px 0px 10px' }}>Not seeing your statement below? Email us at AR@boland.com to get enrolled.</Form.Label>
                <div style={{ width: '400px' }} >
                    <BootstrapTable
                        bootstrap4
                        keyField="DocumentID"
                        wrapperClasses="table-responsive"
                        data={data}
                        columns={columns}

                        onTableChange={this.handleTableChange}
                        noDataIndication={this.loadingSpinner}
                        hover
                    />
                </div>
            </div>
        );
    }
}
export default CustomerStatementPage;